import { api } from '../api/client';

/**
 * Take a fresh upload as far through the content workflow as this person
 * may.
 *
 * An upload starts as a draft, and a course cannot be published (or submitted
 * for review) behind a draft cover. The same three steps the review queue's
 * buttons take, so the audit log reads the same. Anyone who may not approve
 * leaves it in the review queue; a step that is refused — a file still in
 * quarantine, say — stops there, and the course's publish check says what is
 * left.
 *
 * Shared by the course builder and the course wizard, which both upload
 * covers.
 */
export async function settleUpload(
  itemId: string,
  can: (permission: string) => boolean,
): Promise<void> {
  if (!can('CONTENT_SUBMIT_REVIEW')) return;
  try {
    await api(`/content/${itemId}/submit`, { method: 'POST', body: '{}' });
    if (!can('CONTENT_APPROVE') || !can('CONTENT_PUBLISH')) return;
    await api(`/content/${itemId}/approve`, { method: 'POST', body: '{}' });
    await api(`/content/${itemId}/publish`, { method: 'POST', body: '{}' });
  } catch {
    // Left where it stopped; the course still shows the cover as unpublished.
  }
}
